import { render, staticRenderFns } from "./OpenBankingPaymentDetails.vue?vue&type=template&id=a6b59624"
import script from "./OpenBankingPaymentDetails.vue?vue&type=script&lang=js"
export * from "./OpenBankingPaymentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports